import { CfcModel } from "./cfc.model";
import { LocalFotobiometriaModel } from "./local-fotobiometria.model";
import { LocalModel } from "./local.model";
import {FotobiometriaDisponibilidadeModel} from '@models/gestao/fotobiometria-disponibilidade.model';
import {FotoBiometriaModel} from '@models/gestao/fotobiometria.model';

export class FotobiometriaDisponibilidadeBloqueioModel {

  id?: number;
  idLocal?: number;
  idFotobiometriaDisponibilidade?: number;
  idCfc?: number;
  diaSemana?: string;
  turno?: string;
  dataInicio?: any;
  dataFim?: any;
  observacao?: string;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  ativo?: boolean;
  fotobiometria?: FotoBiometriaModel;
  local?: LocalModel;
  fotobiometriaDisponibilidade?: FotobiometriaDisponibilidadeModel;
  cfc?: CfcModel;
  localFotoBiometria?: LocalFotobiometriaModel;
  horario?: any;

  constructor(
    options: FotobiometriaDisponibilidadeBloqueioModel = {}
  ) {
    this.id = options.id || null;
    this.idLocal = options.idLocal || null;
    this.idFotobiometriaDisponibilidade = options.idFotobiometriaDisponibilidade || null;
    this.idCfc = options.idCfc || null;
    this.diaSemana = options.diaSemana || null;
    this.turno = options.turno || null;
    this.dataInicio = options.dataInicio || null;
    this.dataFim = options.dataFim || null;
    this.observacao = options.observacao || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.ativo = options.ativo || null;
    this.fotobiometria = options.fotobiometria || null;
    this.local = options.local || null;
    this.fotobiometriaDisponibilidade = options.fotobiometriaDisponibilidade || new FotobiometriaDisponibilidadeModel();
    this.cfc = options.cfc || new CfcModel();
    this.localFotoBiometria = options.localFotoBiometria || new LocalFotobiometriaModel();
    this.horario = options.horario || null;
  }
}

